import React from "react"
import SideBar from "../../components/sidebar/Sidebar"
import { Box } from "@mui/material"
import PersonaFisicaPage from "./PersonaFisicaPage"

interface ClientePageProps {
  tipo_cliente: "PEF" | "PG"
}

const ClientePage: React.FC<ClientePageProps> = ({ tipo_cliente }) => {

  return (
    <div className="home">
      <SideBar />
      <div className="homeContainer">
        <Box sx={{ width: "100%", marginBottom: "15px" }}>
          <PersonaFisicaPage />
        </Box>
      </div>
    </div>
  )
}

export default ClientePage
